import { deviceModule } from "@/store/device";
import * as Sentry from "@sentry/vue";
import { accountService } from "./AccountService";
import { TimingOfInAppReview } from "@/types/accounts/InAppReview";
import { authStore } from "@/store/auth";

class InAppReviewService {
  /**
   * アプリ内レビューを表示するかどうかを判定し、表示する場合は表示する
   * @param timing 呼び出されたタイミング
   */
  async launchInAppReview(timing: TimingOfInAppReview) {
    if (deviceModule.isBrowser) return;
    try {
      const { shouldShow } = await accountService.shouldShowInAppReview(
        timing,
        deviceModule.isIos ? "iOS" : "Android"
      );
      if (shouldShow) {
        this.launchInAppReviewDialog();
      }
    } catch (e) {
      console.error(e);
    }
  }

  /**
   * アプリ内レビューのダイアログを表示する
   * このメソッドが呼ばれたからといって、必ずダイアログが表示されるわけではないので注意
   * アプリストアの仕様により、ダイアログが表示されるかどうかは最終的にはアプリストア側で決まる
   */
  private launchInAppReviewDialog() {
    // @ts-ignore
    if (LaunchReview.isRatingSupported()) {
      // アプリ内レビューがサポートされている場合
      // @ts-ignore
      // eslint-disable-next-line
      LaunchReview.rating(undefined, function(err: any) {
        console.error("Error launching rating dialog: " + err);
        Sentry.captureException(err);
      });
    } else {
      // アプリ内レビューがサポートされていない場合
      // アプリストアに遷移した上で、ストア内でレビューダイアログを開く
      // @ts-ignore
      LaunchReview.launch(
        undefined,
        // @ts-ignore
        err => {
          Sentry.captureException(err);
        },
        deviceModule.isIos
          ? authStore.product.iosAppId
          : authStore.product.androidAppId
      );
    }
  }
}

export const inAppReviewService = new InAppReviewService();
